<template>
  <div class="mt-3 scan-history-table-wrapper">
    <div style="overflow-x: auto; overflow-y: hidden">
      <table class="table scan-history-table" style="margin: 0">
        <thead>
          <tr>
            <th rowspan="2">No PO</th>
            <th rowspan="2">Label Maker</th>
            <th rowspan="2">PO Date</th>
            <th rowspan="2">Variant</th>
            <th colspan="5" class="text-center">Total</th>
          </tr>
          <tr>
            <th>QR</th>
            <th>Spare</th>
            <th>Scan</th>
            <th>Activate</th>
            <th>Failed</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="data && data.length > 0">
            <template v-for="dat in data">
              <tr v-for="(da, i) in dat.content" :key="`${dat.no_po}-${i}`" :class="{ 'border-top': i == 0 }">
                <td>{{ i == 0 ? (dat.no_po ? dat.no_po : "-") : "" }}</td>
                <td>
                  {{ i == 0 ? (dat.label_maker ? dat.label_maker : "-") : "" }}
                </td>
                <td>
                  {{
                    i == 0
                      ? dat.po_date
                        ? moment(dat.po_date).format("DD MMM YYYY HH:mm:ss")
                        : "-"
                      : ""
                  }}
                </td>
                <td>{{ da.variant ? da.variant : "0" }}</td>
                <td>{{ da.qr_total ? numberWithCommas(da.qr_total) : "0" }}</td>
                <td>
                  {{ da.spare_total ? numberWithCommas(da.spare_total) : "0" }}
                </td>
                <td>{{ da.scan_total ? numberWithCommas(da.scan_total) : "0" }}</td>
                <td>{{ da.activate ? numberWithCommas(da.activate) : "0" }}</td>
                <td>{{ da.failed ? numberWithCommas(da.failed) : "0" }}</td>
              </tr>
            </template>
          </template>
          <tr v-else>
            <td colspan="9" class="text-center">
              <p class="pt-5 pb-5 mb-0">No Data</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      moment: moment,
      dummyData: null,
    };
  },
  props: ["data"],
  mounted() {
    // this.generateDummyData();
  },
  methods: {
    numberWithCommas(x) {
      return Number.parseInt(x)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    generateDummyData() {
      let dummy = [];
      let date = moment();
      let labelMakers = this.$store.getters.getLabelMaker;
      let variants = this.$store.getters.getVariant;

      let names = [
        "Beat",
        "Scoopy",
        "Beatstreet",
        "ADV 150",
        "Genio",
        "ADV",
        "CBR",
        "Genio",
      ];
      for (var i = 0; i < 20; i++) {
        let singleDummy = {
          no_po: `XVI - ${2495 - i}`,
          label_maker:
            labelMakers[this.randomInt(0, 1000) % labelMakers.length],
          po_date: date
            .subtract(this.randomInt(2, 10), "days")
            .format("YYYY-MM-DD HH:mm:ss"),
          content: [],
        };

        variants = this.shuffle(variants);
        for (var j = 0; j < this.randomInt(2, variants.length); j++) {
          let success = this.randomInt(100, 1000);
          let failed = this.randomInt(100, 300);
          let activate = this.randomInt(100, 1000);
          let deactive = this.randomInt(100, 200);

          singleDummy.content.push({
            variant: variants[this.randomInt(0, 1000) % variants.length],
            qr_total: success + failed + deactive + this.randomInt(200, 1000),
            spare_total: this.randomInt(100, 200),
            scan_total: success + failed + deactive + activate,
            success: success,
            failed: failed,
            activate: activate,
            deactive: deactive,
          });
        }

        dummy.push(singleDummy);
      }

      this.dummyData = dummy;
    },
    shuffle(array) {
      let currentIndex = array.length,
        randomIndex;

      // While there remain elements to shuffle...
      while (currentIndex != 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex],
          array[currentIndex],
        ];
      }

      return array;
    },
  },
};
</script>

<style scoped>
/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody {
  display: block;
  max-height: 65vh;
  overflow-y: scroll;
}

.scan-history-table-wrapper .scan-history-table thead,
.scan-history-table-wrapper .scan-history-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.scan-history-table-wrapper .scan-history-table thead {
  width: calc(100% - 10px);
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th.text-center {
  text-align: center;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td.text-center {
  text-align: center;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr.border-top td:not(:first-child) {
  border-top: 1px solid #dee2e6;
}

/* Custom Scrollbar Styling */
.scan-history-table-wrapper .scan-history-table tbody::-webkit-scrollbar {
  width: 10px;
}

.scan-history-table-wrapper .scan-history-table tbody::-webkit-scrollbar-track {
  background-color: white;
  border-radius: 20px;
}

.scan-history-table-wrapper .scan-history-table tbody::-webkit-scrollbar-thumb {
  background-color: #f1f1f1;
  border-radius: 20px;
}

.scan-history-table-wrapper .scan-history-table tbody::-webkit-scrollbar-thumb:hover {
  background-color: #d1d1d1;
}
</style>
